import { CompanyMinifiedRowType } from '@api';
import { TouringDataTable, useManageTableContext } from '@common';
import { useCompaniesOverviewTableColumns, useDeleteCompany } from './hooks';

type CompaniesOverviewTablePropsType = {
  companies: CompanyMinifiedRowType[];
  isPending: boolean;
};

export const CompaniesOverviewTable: React.FC<
  CompaniesOverviewTablePropsType
> = ({ companies, isPending }) => {
  const { handleDeleteCompany } = useDeleteCompany();

  const { columns } = useCompaniesOverviewTableColumns({ handleDeleteCompany });

  const { tableArguments: table } = useManageTableContext();

  return (
    <TouringDataTable<CompanyMinifiedRowType>
      columns={columns}
      records={companies}
      {...table.pagination}
      {...table.sorting}
      fetching={isPending}
    />
  );
};
